import ButtonGroup from './ButtonGroup.jsx';

export default ButtonGroup;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/button-group/index.js